(ns practitest.frontend.components2.dashboard.charts.stacked-progress-bar
  (:require [practitest.frontend.components2.dashboard.charts.render :as r]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.transforms.stacked-progress-bar :as transforms]
            [practitest.frontend.components2.dashboard.events :as-alias events]
            [re-frame.core :as rf]))

(defn- chart-spec [chart toggle-evt]
  (let [legend?       (not= :no-legend (:chart/legend-location chart))
        palette       (:chart/colors-palette chart)
        series-labels (:chart/series chart)
        ordered-range (mapv (fn [label] (get palette label)) series-labels)]
    {:mark            :area
     :padding         {:top 5 :right 20 :bottom 35 :left 35}
     :tooltip         true
     :point           true
     :data            (:chart/data chart)
     :encode          {:x       {:field :date
                                 :type  :temporal
                                 :axis  {:label-angle  -40
                                         :format       "%Y-%m-%d"
                                         :ticks        (when (empty? (:chart/data chart)) false)
                                         :tick-count   (:chart/categories-count chart)
                                         :label-stride (:chart/x-label-visible-step chart)}}
                       :y       {:field :value
                                 :type  :quantitative}
                       :tooltip {:mode        :category-group
                                 :sort        :desc
                                 :show-total? true}
                       :color   (cond-> {:field :group
                                         :type  :nominal
                                         :scale {:domain series-labels
                                                 :range  ordered-range}}
                                  legend?
                                  (assoc :legend {:opacity {:one-of (:chart/inactive-groups chart)}
                                                  :offset 60}))}
     :on-legend-click toggle-evt}))

(defmethod p/render! ::chart/stacked-progress-bar [chart _ctx svg-element]
  (let [toggle-evt #(rf/dispatch [::events/toggle-legend-item (:chart/id chart) %])]
    (r/render-chart! svg-element (chart-spec chart toggle-evt))))

(defmethod p/transform-data ::chart/stacked-progress-bar [chart]
  (transforms/transform chart))
